import { i18n } from "../i18n";
import "../i18n";

export const initializeLanguage = () => {
  const allowedLanguages = ["fr", "en", "de", "ja", "it", "pt", "ko", "es"];
  const defaultLanguage = "en";
  const url = new URL(window.location.href);
  const params = new URLSearchParams(window.location.search);
  const lang = params.get("lang")?.split("-")[0].toLowerCase();

  const langRes = lang
    ? allowedLanguages.includes(lang)
      ? lang
      : defaultLanguage
    : defaultLanguage;

  if (!params.has("lang")) {
    params.append("lang", langRes);
    url.search = params.toString();
    window.history.replaceState({}, "", url.toString());
  }

  i18n.changeLanguage(langRes);

  return langRes;
};

export const convertHeightToFeetAndInches = (heightInCm: string) => {
  const heightStr = heightInCm.toString();

  // If the input length is less than 2, pad with leading zero
  const paddedHeightStr = heightStr.padStart(2, "0");

  // Extract first digit as feet and second digit as inches
  const feetValue = paddedHeightStr[0];
  const inchesValue = paddedHeightStr[1];

  return { feetValue, inchesValue };
};

export const convertFeetAndInchesToCm = (
  feetValue: string,
  inchesValue: string
) => {
  // Combine feet and inches into a single string
  const heightStr = `${feetValue}${inchesValue}`;

  return heightStr;
};

export const INCHtoCM = (v: any) => {
  const [feet, inches] = v.split(" ").map(Number);
  return (feet * 30.48 + inches * 2.54).toFixed(2).toString();
};

export const LBStoKG = (v: number) => (v * 0.453592).toFixed(2).toString();

export const getStepMaps = (isMobile: boolean) => {
  const stepMap = [
    { label: "ABOUT YOU", stepNumber: isMobile ? 2 : 3 },
    { label: "HIPS", stepNumber: 6 },
    { label: "STOMACH", stepNumber: 7 },
    { label: "CHEST", stepNumber: 9 },
    { label: "YOUR SIZE", stepNumber: 12 },
  ];

  return stepMap;
};

export const getInputStyles = ({
  isMobile,
  isAndroid,
  brandDefined,
  font,
  inputStyles,
  inputStyleSelector,
  borderColor,
}: {
  isMobile: boolean;
  isAndroid: boolean;
  brandDefined?: { name?: string } | null;
  font: string;
  inputStyles: React.CSSProperties;
  inputStyleSelector: { borderBottom?: string; border?: string };
  borderColor: string;
}): React.CSSProperties => {
  const isSRP = brandDefined?.name === "SRP";
  const isVB = brandDefined?.name === "Victoria Beckham";
  const isOtherBrand = !isSRP && !isVB;

  const marginBottom = !isMobile && isOtherBrand ? inputStyles.marginBottom : 0;

  const borderBottom =
    inputStyleSelector.borderBottom === "none"
      ? "none"
      : `1px solid ${borderColor}`;

  const border =
    inputStyleSelector.borderBottom === "none" ? "none" : inputStyles.border;

  const width = isMobile
    ? isVB
      ? "calc(100% - 32px)"
      : "calc(100% - 42px)"
    : "100%";

  const maxWidth =
    isMobile && (isVB || isOtherBrand)
      ? isVB
        ? "calc(100% - 32px)"
        : "calc(100% - 42px)"
      : inputStyleSelector.borderBottom === "none" || isSRP || isVB
      ? "calc(100% - 20px)"
      : "100%";

  const fontFamily =
    !isAndroid && font !== "Futura" ? `${font}, sans-serif !important` : "";

  return {
    ...inputStyles,
    marginBottom,
    borderBottom,
    border,
    width,
    maxWidth,
    position: "relative",
    outline: "none",
    fontFamily,
  };
};
